var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-incoming',_vm._g(_vm._b({},'message-incoming',Object.assign({}, _vm.$props, _vm.$attrs),false),_vm.$listeners),[_c('audio',{attrs:{"controls":""}},[_vm._v(_vm._s(_vm.$t("fallbacks.audio_file")))])])}
var staticRenderFns = []

export { render, staticRenderFns }